import axios from 'axios'
import store from '../store/index'
import router from "@/router";
import {UserAgentApplication} from "msal";

const tradutor = axios.create({
    baseURL: process.env.VUE_APP_TRADUTOR_URL
});

const configAzure = {
    auth: {
        clientId: process.env.VUE_APP_CLIENTE_ID_AZURE,
        authority: 'https://login.microsoftonline.com/ORIGOENERGIA.onmicrosoft.com',
        redirectUri: process.env.VUE_APP_REDIRECT_URI_AZURE,
    },

    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,

    }
}

const loginRequest = {
    scopes: ["User.read"],
};
const msal = new UserAgentApplication(configAzure);

function authCallback(error, response) {
    console.log('authCallback', error, response);
    if (error) {
        msal.loginRedirect(loginRequest);
    }
}

msal.handleRedirectCallback(authCallback);

async function obterToken() {
    return await msal.acquireTokenSilent(loginRequest).then((response) => {
        localStorage.setItem('account', JSON.stringify(response.account));
        localStorage.setItem('tokenApi', response.accessToken)
        return 'Bearer ' + response.accessToken;
    }).catch((error) => {
        console.log(error);
        return msal.acquireTokenRedirect(loginRequest);
    });
}

tradutor.interceptors.request.use(async request => {

    const token = await obterToken();

    request.baseURL = process.env.VUE_APP_TRADUTOR_URL
    request.headers['api-token'] = process.env.VUE_API_TOKEN_TRADUTOR
    request.headers['Authorization'] = token
    request.headers['Ocp-apim-productid'] = process.env.VUE_APIM_PRODUCT_ID_TRADUTOR
    request.headers['Ocp-Apim-Subscription-Key'] = process.env.VUE_APIM_SUBSCRIPTION_KEY_TRADUTOR
    const deveTerLoading = !request.url.split('&').includes('loading=false');

    if (deveTerLoading) {
        store.commit('spinner/toggleSpinner', true)
    }
    return request
})

tradutor.interceptors.response.use(response => {
    store.commit('spinner/toggleSpinner', false)
    return response;
}, error => {
    store.commit('spinner/toggleSpinner', false)

    if (error.response.status && ([400, 403, 401].includes(error.response.status))) {
        router.push({name: 'error', query: {error: error.response.status}})
    }

    console.log('error', error);

    return Promise.reject(error)
})

export default tradutor;



// WEBPACK FOOTER //
// ./src/plugins/TradutorInterceptor.js